///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, inject } from '@angular/core';
import { selectSystemInfo } from '../../shared/store/systemInfo/system-info.selectors';
import { Store } from '@ngrx/store';
import { AsyncPipe } from '@angular/common';
import { SuiSvgIconComponent, SuiTranslatePipe } from '@siklu/sui-lib';
import { MatDialogActions, MatDialogClose, MatDialogConfig, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { ButtonsDirectivesModule } from '../../shared/directives/buttons-directives/buttons-directives.module';

@Component({
    selector: 'winde-about-modal',
    imports: [
        AsyncPipe,
        SuiTranslatePipe,
        MatDialogTitle,
        MatDialogClose,
        SuiSvgIconComponent,
        MatDialogActions,
        MatDialogContent,
        ButtonsDirectivesModule
    ],
    templateUrl: './about-winde-dialog.component.html'
})
export class AboutWindeDialogComponent {
    public static readonly DIALOG_CONFIG: MatDialogConfig = {
        width: '500px',
        position: {
            top: '30px'
        },
        closeOnNavigation: true
    };

    public systemInfo$ = inject(Store).select(selectSystemInfo);
}
